import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

/**
 * Select: Drop-down list.
 */
const Select = ({ options, selected, label, color, handleChange, children }) => {
  const selectedOption = options[selected] || {};

  return (
    <div className={styles.select}>
      {label && <span>{label}</span>}
      <span className={`${styles.value} text-truncate`} style={{ color }}>
        {selectedOption.label}
      </span>
      <i className="icon-budicon-460" />
      <select
        // Pass event and selected option object to onChange handler
        onChange={e => handleChange(e, options.filter(opt => opt.value === e.target.value)[0])}
        value={selectedOption.value}
      >
        {children || options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

Select.defaultProps = {
  selected: 0,
  label: '',
  handleChange: () => {},
  color: undefined
};

Select.propTypes = {
  /**
   * List of options
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * Index of default selected value
   */
  selected: PropTypes.number,
  /**
   * Handler for option change, it receives two parameters:
   * the event and the selected option object.
   */
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  color: PropTypes.string
};

export default Select;
